import React from 'react'
import { isMobile, isTablet } from "react-device-detect"
import OffersDisplay from './OffersDisplay'

const EirOffers = (props) => {

    if (!isMobile && props.offersDisplay === 'desktop-only') {
        return (
            <OffersDisplay offers={props} />
        )
    } else if (isMobile && props.offersDisplay === 'mobile-only') {
        return (
            <OffersDisplay offers={props} />
        )
    } else if (props.offersDisplay === 'both') {
        return (
            <OffersDisplay offers={props} />
        )
    } else {
        return <div></div>
    }
}

export default EirOffers